import { render, staticRenderFns } from "./HomeProcurement.vue?vue&type=template&id=f502004e&scoped=true&"
import script from "./HomeProcurement.vue?vue&type=script&lang=js&"
export * from "./HomeProcurement.vue?vue&type=script&lang=js&"
import style0 from "./HomeProcurement.vue?vue&type=style&index=0&id=f502004e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f502004e",
  null
  
)

export default component.exports